import type { ItineraryConstraint$options, ItineraryTravelMode$options } from '$houdini';
import { tripConstraints } from '$lib/i18n/computedMessages';
import * as m from '$paraglide/messages';

export type BadgesNames = 'electricCar' | 'car' | 'motorcycle' | 'caravan';

const badges: Record<BadgesNames, () => string> = {
	electricCar: () => m.bookmark__badge_electricCar(),
	car: () => m.bookmark__badge_car(),
	motorcycle: () => m.bookmark__badge_motorcycle(),
	caravan: () => m.bookmark__badge_caravan(),
};

export function formatBadges(
	isEv: boolean,
	withCaravan: boolean,
	mode: Extract<ItineraryTravelMode$options, 'CAR' | 'MOTORCYCLE'>,
	constraints: ItineraryConstraint$options | null,
): string[] {
	const badgeNames: BadgesNames[] = [];

	if (isEv) {
		badgeNames.push('electricCar');
	} else {
		badgeNames.push(mode.toLowerCase() as BadgesNames);
	}

	if (withCaravan) {
		badgeNames.push('caravan');
	}

	const result = badgeNames.map(name => badges[name]());

	if (constraints && constraints !== 'NONE') {
		result.push(tripConstraints(constraints));
	}

	return result;
}
